/**
 * Account 関連の純粋関数（ロジック層）
 */

/** バリデーション対象フィールド定義 */
export interface AddressFieldConfig {
  name: string;
  errorId: string;
}

/** バリデーション結果 */
export interface ValidationResult {
  isValid: boolean;
  errors: string[];
}

/** 住所フォームの必須フィールド */
export const ADDRESS_REQUIRED_FIELDS: AddressFieldConfig[] = [
  { name: 'address[last_name]', errorId: 'message-error-last-name' },
  { name: 'address[first_name]', errorId: 'message-error-first-name' },
  { name: 'address[country]', errorId: 'message-error-country' },
  { name: 'address[province]', errorId: 'message-error-province' },
  { name: 'address[city]', errorId: 'message-error-city' },
  { name: 'address[address1]', errorId: 'message-error-addr1' },
  { name: 'address[phone]', errorId: 'message-error-phone' },
];

/**
 * 住所フォームのバリデーション
 *
 * @param formData - フォームデータ（フィールド名 → 値のマップ）
 * @param requiredFields - 必須フィールド定義（デフォルト: ADDRESS_REQUIRED_FIELDS）
 * @returns バリデーション結果
 */
export function validateAddressForm(
  formData: Record<string, string>,
  requiredFields: AddressFieldConfig[] = ADDRESS_REQUIRED_FIELDS,
): ValidationResult {
  const errors: string[] = [];

  for (const field of requiredFields) {
    const value = formData[field.name] ?? '';
    if (value.trim() === '') {
      errors.push(field.name);
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}
